export default __webpack_public_path__ + "static/media/bancoomeva.22f8c57f.svg";